import { useGetSiteSettingsQuery } from '../../app/api';

export const Currency = ({ value }: { value: number }) => {
  const { data, isLoading } = useGetSiteSettingsQuery();
  if (isLoading) {
    return <span>Loading...</span>;
  }
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: data?.currency,
  });
  return <span>{formatter.format(value)}</span>;
};
